module.exports = __webpack_public_path__ + "static/Disclaimer-bf5b91b7837724a4b097147e8f173d6e.pdf";